import React, { useEffect, useState } from 'react';

const HomePageTrustpilot = ({ useMobileLayoutOnly = false, useMobileLayoutBelow770 = false }) => {
  const [data, setData] = useState({
    trustScore: '4.6',
    totalReviews: '3.329',
    starsString: 'Eccezionale'
  });
  const stars = Array.from({ length: 5 });
  const desktopBreakpointPrefix = useMobileLayoutBelow770 ? 'min-[770px]:' : 'md:'
  const rootClassName = useMobileLayoutOnly
    ? "bg-white flex flex-col gap-[8px] items-center p-[12px] relative rounded-[8px] shadow-[0px_4px_16px_0px_rgba(0,0,0,0.06)] w-full hover:shadow-[0px_8px_24px_0px_rgba(0,0,0,0.12)] transition-shadow duration-300 no-underline z-10"
    : `bg-white flex flex-col gap-[8px] items-center p-[12px] relative rounded-[8px] shadow-[0px_4px_16px_0px_rgba(0,0,0,0.06)] w-full max-w-[396px] hover:shadow-[0px_8px_24px_0px_rgba(0,0,0,0.12)] transition-shadow duration-300 no-underline z-10 ${desktopBreakpointPrefix}w-auto ${desktopBreakpointPrefix}max-w-none ${desktopBreakpointPrefix}flex-row ${desktopBreakpointPrefix}items-center ${desktopBreakpointPrefix}gap-[8px] ${desktopBreakpointPrefix}p-[16px] ${desktopBreakpointPrefix}rounded-[12px]`
  const brandClassName = useMobileLayoutOnly
    ? "flex gap-[8px] items-center shrink-0"
    : `flex gap-[8px] items-center shrink-0 ${desktopBreakpointPrefix}border-b-0 ${desktopBreakpointPrefix}border-r ${desktopBreakpointPrefix}border-[#E5E7EB] ${desktopBreakpointPrefix}pb-0 ${desktopBreakpointPrefix}pr-[12px]`
  const brandIconClassName = useMobileLayoutOnly
    ? "relative shrink-0 flex h-[20px] w-[20px] items-center justify-center"
    : `relative shrink-0 flex h-[20px] w-[20px] items-center justify-center ${desktopBreakpointPrefix}h-[24px] ${desktopBreakpointPrefix}w-[24px]`
  const brandTextClassName = useMobileLayoutOnly
    ? "m-0 whitespace-nowrap font-['Inter'] text-[16px] font-bold capitalize leading-[20px] tracking-[0.16px] text-[#262f39]"
    : `m-0 whitespace-nowrap font-['Inter'] text-[16px] font-bold capitalize leading-[20px] tracking-[0.16px] text-[#262f39] ${desktopBreakpointPrefix}text-[24px] ${desktopBreakpointPrefix}tracking-[0.24px]`
  const bodyClassName = useMobileLayoutOnly
    ? "flex w-full flex-col items-center justify-center gap-[8px]"
    : `flex w-full flex-col items-center justify-center gap-[8px] ${desktopBreakpointPrefix}w-auto ${desktopBreakpointPrefix}flex-row ${desktopBreakpointPrefix}flex-wrap ${desktopBreakpointPrefix}items-center ${desktopBreakpointPrefix}gap-[16px] ${desktopBreakpointPrefix}pl-[4px]`
  const starsRowClassName = useMobileLayoutOnly
    ? "flex w-full justify-center gap-[4px] leading-[0] shrink-0"
    : `flex w-full justify-center gap-[4px] leading-[0] shrink-0 ${desktopBreakpointPrefix}w-auto ${desktopBreakpointPrefix}justify-start`
  const starClassName = useMobileLayoutOnly
    ? "flex h-[20px] w-[20px] items-center justify-center rounded-[2px] bg-[#00B67A]"
    : `flex h-[20px] w-[20px] items-center justify-center rounded-[2px] bg-[#00B67A] ${desktopBreakpointPrefix}h-[24px] ${desktopBreakpointPrefix}w-[24px] ${desktopBreakpointPrefix}rounded-sm`
  const starIconClassName = useMobileLayoutOnly
    ? "h-[15px] w-[15px]"
    : `h-[15px] w-[15px] ${desktopBreakpointPrefix}h-[14px] ${desktopBreakpointPrefix}w-[14px]`
  const detailsClassName = useMobileLayoutOnly
    ? "flex w-full min-w-0 flex-wrap items-center justify-center gap-x-[4px] gap-y-0 text-center text-[12px] tracking-[0.12px] text-[#6d6d6d]"
    : `flex w-full min-w-0 flex-wrap items-center justify-center gap-x-[4px] gap-y-0 text-center text-[12px] tracking-[0.12px] text-[#6d6d6d] ${desktopBreakpointPrefix}w-auto ${desktopBreakpointPrefix}shrink-0 ${desktopBreakpointPrefix}flex-nowrap ${desktopBreakpointPrefix}justify-start ${desktopBreakpointPrefix}text-left ${desktopBreakpointPrefix}text-[16px] ${desktopBreakpointPrefix}tracking-[0.16px]`

  useEffect(() => {
    const fetchTrustpilotData = async () => {
      try {
        const response = await fetch(
          'https://widget.trustpilot.com/trustbox-data/53aa8807dec7e10d38f59f32?businessunitId=611bb39c0f8bab001f63afb9&locale=it-IT'
        );
        if (response.ok) {
          const json = await response.json();
          setData({
            trustScore: json.businessUnit?.trustScore?.toString() || '4.6',
            totalReviews: json.businessUnit?.numberOfReviews?.total?.toLocaleString('it-IT') || '3.329',
            starsString: json.starsString || 'Eccezionale'
          });
        }
      } catch (error) {
        console.error('Failed to fetch Trustpilot data:', error);
      }
    };

    fetchTrustpilotData();
  }, []);

  return (
    <a
      href="https://it.trustpilot.com/review/smartcaf.it"
      target="_blank"
      rel="noreferrer"
      aria-label="Apri il profilo Trustpilot di SmartCaf"
      className={rootClassName}
    >
      <div className={brandClassName}>
        <div className={brandIconClassName}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-full w-full">
            <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" fill="#00B67A" />
          </svg>
        </div>
        <p className={brandTextClassName}>
          trustpilot
        </p>
      </div>

      <div className={bodyClassName}>
        <div className={starsRowClassName}>
          {stars.map((_, index) => (
            <div key={index} className={starClassName}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" className={starIconClassName}>
                <path d="M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z" />
              </svg>
            </div>
          ))}
        </div>

        <div className={detailsClassName}>
          <p className="m-0 font-['Inter'] font-medium leading-[20px] text-[#6d6d6d]">
            {data.starsString}
          </p>
          <p className="m-0 font-['Inter'] font-semibold leading-[20px] text-[#262f39]">
            {data.trustScore}/5 <span className="text-[#6d6d6d]">.</span>
          </p>
          <p className="m-0 font-['Inter'] font-medium leading-[20px] text-[#6d6d6d]">
            Basato su <span className="text-[#262f39]">{data.totalReviews}</span> recensioni
          </p>
        </div>
      </div>
    </a>
  );
};

export default HomePageTrustpilot;